export default function BarChart({ data, title, color = "#66ffb7", maxItems = 10, showRain }) {
  if (!data || data.length === 0) {
    return (
      <div className="bar-chart empty">
        <h4>{title}</h4>
        <div className="no-data">No data available</div>
      </div>
    );
  }

  const items = data.slice(0, maxItems);
  const maxCount = Math.max(...items.map((d) => d.count));

  return (
    <div className={`bar-chart ${showRain ? "matrix-chart" : ""}`}>
      <h4>{title}</h4>
      <div className="bar-chart-items">
        {items.map((item, idx) => {
          const pct = maxCount ? (item.count / maxCount) * 100 : 0;
          return (
            <div key={item.name || idx} className="bar-item">
              <div className="bar-label" title={item.name}>
                {item.name}
              </div>
              <div className="bar-track">
                <div
                  className="bar-fill"
                  style={{
                    width: `${pct}%`,
                    background: showRain ? `linear-gradient(90deg, ${color}, ${color}88)` : color,
                    boxShadow: showRain ? `0 0 10px ${color}60` : "none",
                  }}
                />
              </div>
              <div className="bar-count">{item.count}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
